export const Nationalities = [
  "Afghan",
  "Albanian",
  "Algerian",
  "American Samoa",
  "Andorran",
  "Angolan",
  "Anguilla",
  "Antigua and Barbuda",
  "Argentine",
  "Armenian",
  "Aruban",
  "Australian",
  "Austrian",
  "Azerbaijani",
  "Bangladeshi",
  "Barbados",
  "Bahamian",
  "Bahraini",
  "Belarusian",
  "Belgian",
  "Belizean",
  "Benin",
  "Bermudian",
  "Bhutanese",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Batswana",
  "Brazillian",
  "British Indian Ocean Territory",
  "British citizen",
  "Brunei Darussalam",
  "Bulgarian",
  "Burkina Faso",
  "Myanmar",
  "Burundian",
  "Cambodian",
  "Cameroonian",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chadian",
  "Chilean",
  "Chinese",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombian",
  "Comorian",
  "Congo-Brazzaville",
  "Congo-Kinshasa",
  "Cook Islands",
  "Costa Rica",
  "Croatian",
  "Curagao",
  "Cypriot",
  "Czech Republic",
  "Danes",
  "Djiboutian",
  "Dominican",
  "Dominican Republic",
  "East Timor",
  "Ecuadorian",
  "El Salvador",
  "Egyptian",
  "Equatorial Guinean",
  "Eritrean",
  "Estonian",
  "Ethiopian",
  "Falkland Islands",
  "Faroe Islands",
  "Federated States of Micronesia",
  "Fiji",
  "Finnish",
  "French",
  "French Guiana",
  "French Polynesia",
  "French Southern Lands",
  "Gabon",
  "Gambian",
  "Georgian",
  "German",
  "Ghanaian",
  "Gibraltar",
  "Greek",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinean",
  "Guinea-Bissau",
  "Guyana",
  "Haitian",
  "Heard and McDonald Islands",
  "Honduras",
  "Hong Kong",
  "Hungarian",
  "Iceland",
  "Indian",
  "Indonesian",
  "Iraqi",
  "Irish",
  "Isle of Man",
  "Israeli",
  "Italian",
  "Jamaican",
  "Japanese",
  "Jersey",
  "Jordanian",
  "Kazakh",
  "Kenyan",
  "Kiribati",
  "Kuwaiti",
  "Non-Kuwaiti",
  "Kyrgyz",
  "Laos",
  "Latvian",
  "Lebanese",
  "Lesotho",
  "Liberian",
  "Libyan",
  "Liechtenstein",
  "Lithuanian",
  "Luxembourg",
  "Macau",
  "Macedonian",
  "Madagascar",
  "Malawian",
  "Malaysian",
  "Dhivehin",
  "Malian",
  "Maltese",
  "Marshall Islands",
  "Martinique",
  "Mauritanian",
  "Mauritius",
  "Mayotte",
  "Mexican",
  "Moldovan",
  "Monegasque",
  "Mongolian",
  "Montenegro",
  "Montserrat",
  "Moroccan",
  "Mozambican",
  "Namibian",
  "Nauru",
  "Nepalese",
  "Dutch",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigerian",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norwegian",
  "Omanis",
  "Pakistani",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Filipino",
  "Pitcairn Islands",
  "Polish",
  "Portuguese",
  "Puerto Rico",
  "Qatari",
  "Runion",
  "Romanian",
  "Russian",
  "Rwandan",
  "Saint Barthlemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre and Miquelon",
  "Saint Vincent",
  "Samoan",
  "San Marino",
  "Sio Tom and Principe",
  "Saudi Arabian",
  "Senegalese",
  "Serbian",
  "Seychelles",
  "Sierra Leonean",
  "Singaporean",
  "Sint Maarten",
  "Slovak",
  "Slovenian",
  "Solomon Islands",
  "Somali",
  "South African",
  "South Georgian",
  "South Korean",
  "Spanish",
  "Sri Lankan",
  "Sudanese",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swedish",
  "Swazi",
  "Swiss",
  "Syrian",
  "Taiwanese",
  "Tajik",
  "Tanzanian",
  "Thai",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisian",
  "Turkish",
  "Turkmen",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Ugandan",
  "Ukrainian",
  "United Arab Emirates",
  "British citizen",
  "USA",
  "Uruguayan",
  "Uzbek",
  "Vanuatu",
  "Vatican City",
  "Vietnamese",
  "Venezuela",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemeni",
  "Zambian",
  "Zimbabwean",
];

export const Countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bangladesh",
  "Barbados",
  "Bahamas",
  "Bahrain",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Indian Ocean Territory",
  "British Virgin Islands",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burma",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo-Brazzaville",
  "Congo-Kinshasa",
  "Cook Islands",
  "Costa Rica",
  "Croatia",
  "Curagao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "El Salvador",
  "Egypt",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Federated States of Micronesia",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Lands",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard and McDonald Islands",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn Islands",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Runion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Barthlemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre and Miquelon",
  "Saint Vincent",
  "Samoa",
  "San Marino",
  "Sio Tom and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Sweden",
  "Swaziland",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Vietnam",
  "Venezuela",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];
